import type { Subskill } from '@pages/PracticePage/model';

import { cn } from '@shared/lib/utils';
import { Heading } from '@shared/ui';

import { getScoreColor } from '../lib/getScoreColor';

interface SubskillsGridProps {
  subskills: Subskill[];
}

export const SubskillsGrid = ({ subskills }: SubskillsGridProps) => {
  return (
    <section>
      <Heading tag="h2" size="base" aboveCard>
        Subskills to improve
      </Heading>
      <div className="mt-3 flex flex-row justify-between gap-2">
        {subskills.map((skill) => (
          <div
            key={skill.title}
            className="
              flex min-h-[108px] w-[216px] flex-col justify-between rounded-xl
              border border-border/60 bg-card p-4 shadow-sm
            "
          >
            <div className="text-[16px] font-medium text-foreground">{skill.title}</div>
            <div className="flex items-center justify-between">
              <span className={cn('text-lg font-medium', getScoreColor(skill.score))}>
                {skill.score}%
              </span>
              <span className="text-xs text-muted-foreground">{skill.category}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
